import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { FormattedMessage, useIntl } from "react-intl";
import {
  editPaymentMethod,
  getAllCities,
  getAllCountries,
  getAllCurrencies,
  getPaymentMethod,
} from "store/actions";
import Loader from "components/shared/loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SaveChangesButton from "components/Form/SaveChangesButton";
import Form from "components/Form";
import Input from "components/Form/Input";
import ReactSelect from "components/Form/ReactSelect";
import { cutImageFullPath, getId, handleErrMsg } from "helpers/functions";
import { Card, Col, Row } from "react-bootstrap";
import "styles/applications.css";

const EditPaymentMethod = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const { loading, error, singlePaymentMethod } = useSelector(
    (state) => state.paymentMethods
  );
  const {
    countries,
    currencies,
    cities,
    loading: dataLoading,
  } = useSelector((state) => state?.data) || [];

  const [images, setImages] = useState([]);

  useEffect(() => {
    setImages(singlePaymentMethod?.images || []);
  }, [singlePaymentMethod]);

  useEffect(() => {
    dispatch(getPaymentMethod(id));
    if (!countries?.length > 0) dispatch(getAllCountries());
    if (!cities?.length > 0) dispatch(getAllCities());
    if (!currencies?.length > 0) dispatch(getAllCurrencies());
  }, [dispatch, id, countries?.length, cities?.length, currencies?.length]);

  useEffect(() => {
    if (Object.keys(error)?.length > 0) {
      toastErrorMessage(formatMessage({ id: handleErrMsg(error) }), locale);
    }
  }, [error, formatMessage, locale, navigate]);

  let resetValues = {
    ...singlePaymentMethod,
    currency: getId(singlePaymentMethod?.currency),
    country: getId(singlePaymentMethod?.country),
    city: getId(singlePaymentMethod?.city),
  };

  const onSubmit = (data) => {
    data.icon = cutImageFullPath(data?.icon);
    data.images = images;

    dispatch(editPaymentMethod({ id, data, navigate }));
    // setEditAppInfoCheck(!editAppInfoCheck);
  };

  if (loading || dataLoading) return <Loader />;

  return (
    <div className="applications form-group">
      <Col lg={12}>
        <Form onSubmit={onSubmit} defaultValues={resetValues}>
          <Card>
            <Row>
              <Input name="bankName" />
              <Input name="accountHolderName" />
              <Input name="accountNumber" />

              <ReactSelect name="currency" options={currencies} />
              <Input name="iban" />
              <Input name="swiftCode" />
              <Input
                type="checkbox"
                name="isDefault"
                rules={{ required: false }}
              />
            </Row>
          </Card>
          <Card>
            <Row>
              <h5>
                <FormattedMessage id={"bankBranchAddress"} />
              </h5>
              <ReactSelect name="country" options={countries} lg="6" />
              <ReactSelect
                name="city"
                filterAgainst="country"
                options={cities}
                lg="6"
              />
              <Input name="streetName" />
              <Input name="postCode" />
            </Row>
          </Card>
          <SaveChangesButton className="mt-2 justify-content-end" />
        </Form>
      </Col>
    </div>
  );
};

export default EditPaymentMethod;
